const VIDEO_PROPERTIES = [
  'width',
  'height',
  'profileIdc',
  'levelIdc',
  'profileCompatibility',
  'sarRatio'
];


export default VIDEO_PROPERTIES;
